import { render, staticRenderFns } from "./QRcode.vue?vue&type=template&id=d925c4b0&scoped=true&lang=pug&"
import script from "./QRcode.vue?vue&type=script&lang=js&"
export * from "./QRcode.vue?vue&type=script&lang=js&"
import style0 from "./QRcode.vue?vue&type=style&index=0&id=d925c4b0&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d925c4b0",
  null
  
)

export default component.exports